import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONSTANTS_TOKEN } from '../config';

@Injectable({
  providedIn: 'root'
})
export class PortalService {
  private readonly http = inject(HttpClient);
  private readonly constants = inject(CONSTANTS_TOKEN);
  portalType: string = inject(CONSTANTS_TOKEN).app.portalType;

  private baseUrl: string =
    this.portalType === 'admin' ? this.constants.api.baseUrlPortal : this.constants.api.baseUrlAuth;

  get(url: string, options: any = {}): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}${url}`, options);
  }

  post(url: string, payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${url}`, payload);
  }

  put(url: string, payload: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}${url}`, payload);
  }

  delete(url: string, id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}${url}/${id}`);
  }
}
